<template>
  <div id="call_campaign_pause_modal">
    <CustomModal
      title="Pause Call Campaign?"
      width="32vw"
      :visible="visible"
      @update:visible="$emit('update:visible', $event)"
    >
      <div class="flex flex-col gap-[14px]">
        <span class="text-sm font-normal"
          >Closing the Nav bar will pause the Call Campaign.</span
        >
        <span class="text-sm secondary_color"
          >Tip: You can resume the campaign later in the Call Campaigns menu.
          Ongoing calls will not be disconnected.</span
        >
      </div>

      <template #footer>
        <div class="flex flex-row items-center gap-2">
          <a-button class="secondary_medium" @click="handleClose"
            >Cancel</a-button
          >
          <a-button class="primary_medium" @click="handlePauseCampaign"
            >Pause Campaign</a-button
          >
        </div>
      </template>
    </CustomModal>
  </div>
</template>

<script setup>
import CustomModal from "@/src/components/CustomModal.vue";
import {
  handleCampaignStatusUpdateUtils,
  toUpdateCallCampaign,
} from "@/src/utils/callsUtils.js";
import { callCampaignStatuses } from "@/src/constants/callConstants.js";
import store from "@/src/store/index.js";
import { message } from "ant-design-vue";

const props = defineProps({
  visible: { type: Boolean, required: true },
});

const emits = defineEmits(["update:visible", "confirm"]);

const handleClose = async () => {
  try {
    emits("update:visible", false);
  } catch (error) {
    console.error("An error occurred while handling cancel: ", error);
  }
};

const handlePauseCampaign = async () => {
  try {
    const payload = { status: callCampaignStatuses.PAUSED };
    const response = await toUpdateCallCampaign(
      store.getters["callsCampaign/currentCampaignId"],
      payload,
    );

    if (response) {
      await handleCampaignStatusUpdateUtils(callCampaignStatuses.PAUSED);
      message.success("Campaign paused");
      emits("confirm");
      await handleClose();
    }
  } catch (error) {
    console.error("An error occurred while handling pause campaign: ", error);
  }
};
</script>
